import { render, staticRenderFns } from "./ResumeRecipient.vue?vue&type=template&id=3b2faab0"
import script from "./ResumeRecipient.vue?vue&type=script&lang=js"
export * from "./ResumeRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports